import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { DxDataGridComponent } from "devextreme-angular";
import { NotificationService } from "../common/component/notification/notification.service";
import { SiteProvince } from "../common/model/shared.model";
import { SiteService } from "../plant/services/site.service";
import { SiteSummaryService } from "./site-summary.service";
import { SharedService } from "../services/SharedService";
import { Subscription } from 'rxjs';
import { SharedComponentService } from "../common/service/sharedcomponent.service";

@Component({
    selector: 'site-summary',
    templateUrl: './site-summary.component.html',
    styleUrls: ['./site-summary.component.scss']
})

export class SiteSummaryComponent implements OnInit {

    isLoadPanelVisible: boolean = false;
    siteId: number;
    site: SiteProvince[];
    legalEntityOwners: any[];
    companyOwners: string;
    siteGasSummary: any;
    productionFacilities: any;
    onsiteSupplies: any;
    onsiteDemands: any;
    pipelineSupplies: any;
    pipelineDemands: any;
    show: boolean = false;
    selectedMaterialId: number;
    selectedPipelineId: number;
    @ViewChild("PipelineDemandGrid", { static: false }) pipelineDemandGrid: DxDataGridComponent;
    @ViewChild("PipelineSupplyGrid", { static: false }) pipelineSupplyGrid: DxDataGridComponent;
    @ViewChild("ProductionFacilitiesGrid", { static: false }) productionFacilitiesGrid: DxDataGridComponent;
    refreshEventSubscription: Subscription;

    constructor(private route: ActivatedRoute, private router: Router, private siteService: SiteService,
         private notificationService: NotificationService, private siteSummaryService: SiteSummaryService,
         private sharedSvc : SharedService, private sharedComponentService: SharedComponentService) {
            this.sharedSvc.previousRouteToEditFacility = "sitesummary";

    }

    ngOnInit(): void {
        this.sharedComponentService.sendEvent();
        this.route.params.subscribe(params => {
            if (params['id'] != null) {
                this.siteId = params['id'];
                this.getSiteAndProvince(this.siteId);
                this.getCompanyOwnrs(this.siteId);
                this.getSiteGasSummary(this.siteId);
                this.getOnsiteDemands(this.siteId);
                this.getOnsiteSupplies(this.siteId);
                this.getPipelineSupplies(this.siteId);
                this.getPipelineDemands(this.siteId);
                this.getProductionFacilities(this.siteId);
            }
        });

        this.addPipelineDemand = this.addPipelineDemand.bind(this);
        this.editPipelineDemand = this.editPipelineDemand.bind(this);
        this.addFacility = this.addFacility.bind(this);
        this.editFacility = this.editFacility.bind(this);
        this.addSite = this.addSite.bind(this);
        this.editSite = this.editSite.bind(this);
    }

    getSiteAndProvince(siteId) {
        this.isLoadPanelVisible = true;
        this.siteService.getSiteAndProvince(siteId).subscribe({
            next: site => {
                this.site = site;
                this.show = true;
                this.isLoadPanelVisible = false;
            }, error: (error: any) => {
                this.isLoadPanelVisible = false;
                this.notificationService.alert("error", "Error while fetching Site Details", error);
            }
        });
    }

    getCompanyOwnrs(siteId) {
        this.isLoadPanelVisible = true;
        this.siteSummaryService.getCompanyOwners(siteId).subscribe({
            next: legalEntityOwners => {
                this.legalEntityOwners = legalEntityOwners;
                this.companyOwners = this.legalEntityOwners.join(", ");
                this.isLoadPanelVisible = false;
            }, error: (error: any) => {
                this.isLoadPanelVisible = false;
                this.notificationService.alert("error", "Error while fetching Company Owners", error);
            }
        });
    }

    getSiteGasSummary(siteId) {
        this.isLoadPanelVisible = true;
        this.siteSummaryService.getSiteGasSummary(siteId).subscribe({
            next: siteGasSummary => {
                this.siteGasSummary = siteGasSummary;
                this.isLoadPanelVisible = false;
            }, error: (error: any) => {
                this.isLoadPanelVisible = false;
                this.notificationService.alert("error", "Error while fetching Site Gas Summary", error);
            }
        });
    }

    getOnsiteSupplies(siteId) {
        this.isLoadPanelVisible = true;
        this.siteSummaryService.getOnsiteSupplies(siteId).subscribe({
            next: onsiteSupplies => {
                this.onsiteSupplies = onsiteSupplies;
                this.isLoadPanelVisible = false;
            }, error: (error: any) => {
                this.isLoadPanelVisible = false;
                this.notificationService.alert("error", "Error while fetching Onsite Supplies", error);
            }
        });
    }

    editPipelineDemand() {
        if (this.pipelineDemandGrid.instance.getSelectedRowsData()[0]) {
            this.selectedMaterialId = this.pipelineDemandGrid.instance.getSelectedRowsData()[0].materialId;
            this.selectedPipelineId = this.pipelineDemandGrid.instance.getSelectedRowsData()[0].pipelineId;
        } else if (this.pipelineSupplyGrid.instance.getSelectedRowsData()[0]) {
            this.selectedMaterialId = this.pipelineSupplyGrid.instance.getSelectedRowsData()[0].materialId;
            this.selectedPipelineId = this.pipelineSupplyGrid.instance.getSelectedRowsData()[0].pipelineId;
        }

        if (this.selectedPipelineId && this.selectedMaterialId) {
            this.router.navigate([`/pipelines/${this.selectedPipelineId}/${this.selectedMaterialId}`]);
        } else {
            this.notificationService.alert("error", "Please select any pipeline", null);
        }
    }

    addPipelineDemand() {
        this.router.navigate([`/pipelines`]);
    }

    editFacility() {    
        if (this.productionFacilitiesGrid.instance.getSelectedRowsData()[0] && this.productionFacilitiesGrid.instance.getSelectedRowsData()[0].productionFacilityID) {
            this.router.navigate([`/facility/${this.siteId}/${this.productionFacilitiesGrid.instance.getSelectedRowsData()[0].productionFacilityID}`]);
        } else {
            this.notificationService.alert("error", "Please select any production facility", null);
        }
    }

    addFacility() {
        this.router.navigate([`/facility/${this.siteId}`]);
    }

    editSite() {
        this.sharedSvc.previousRouteToEditSite = "sitesummary/";
        this.router.navigate([`/editsite/${this.siteId}`]);
    }

    addSite() {
        this.sharedSvc.previousRouteToEditSite = "sitesummary/";
        this.router.navigate([`/editsite`]);
    }

    onSelectionChanged(e) {
        if (e.element.id == 'PipelineDemandGrid') {
            this.pipelineSupplyGrid.instance.clearSelection();
        }

        if (e.element.id == 'PipelineSupplyGrid') {
            this.pipelineDemandGrid.instance.clearSelection();
        }
    }

    getOnsiteDemands(siteId) {
        this.isLoadPanelVisible = true;
        this.siteSummaryService.getOnsiteDemands(siteId).subscribe({
            next: onsiteDemands => {
                this.onsiteDemands = onsiteDemands;
                this.isLoadPanelVisible = false;
            }, error: (error: any) => {
                this.isLoadPanelVisible = false;
                this.notificationService.alert("error", "Error while fetching Onsite Demands", error);
            }
        });
    }

    getPipelineSupplies(siteId) {
        this.isLoadPanelVisible = true;
        this.siteSummaryService.getPipelineSupplies(siteId).subscribe({
            next: pipelineSupplies => {
                this.pipelineSupplies = pipelineSupplies;
                this.isLoadPanelVisible = false;
            }, error: (error: any) => {
                this.isLoadPanelVisible = false;
                this.notificationService.alert("error", "Error while fetching Pipeline Supplies", error);
            }
        });
    }

    getPipelineDemands(siteId) {
        this.isLoadPanelVisible = true;
        this.siteSummaryService.getPipelineDemands(siteId).subscribe({
            next: pipelineDemands => {
                this.pipelineDemands = pipelineDemands;
                this.isLoadPanelVisible = false;
            }, error: (error: any) => {
                this.isLoadPanelVisible = false;
                this.notificationService.alert("error", "Error while fetching Pipeline Demands", error);
            }
        });
    }

    getProductionFacilities(siteId) {
        this.isLoadPanelVisible = true;
        this.siteSummaryService.getProductionFacilities(siteId).subscribe({
            next: productionFacilities => {
                this.productionFacilities = productionFacilities;
                this.isLoadPanelVisible = false;
            }, error: (error: any) => {
                this.isLoadPanelVisible = false;
                this.notificationService.alert("error", "Error while fetching Production Facilities", error);
            }
        });
    }

    onClosebtnClicked(e){
        this.router.navigate([`/plants`]);
    }

}